<template>
  <div class="page  update-page">
    <Header title="身份转移"></Header>
    <div class="clint-info-box" v-if="!isSelect">
      <div class="notice-bar">
        <div class="notice-bar-info">注意：①此操作不可逆，请慎重操作；②身份转移后当前账号将被注销</div>
      </div>

      <div class="content">
          <van-form @submit="onSubmit" :show-error="false" ref="submitForm">
            <van-field v-model="params.userName" label="转移对象" @click="handleSelect()"
              placeholder="点击选择转移对象" right-icon="arrow" readonly/>
            <van-field v-model="params.verifyCode" type="number" label="验证码"
              placeholder="请输入验证码"
              :rules="[{ required: true, message: '请输入验证码' }]" >
              <template #button>
                <div :style="disableSendBtn?'color:grey':'color:#00545e'" @click="getVerifyCode">获取验证码{{countDownText}}</div>
              </template>
            </van-field>
            <div style="margin: 16px;">
              <van-button color="#00545e" @click="onSubmit" block type="info" native-type="submit">确认转移</van-button>
            </div>
          </van-form>
      </div>
    </div>

    <div v-if="isSelect">
      <div class="worker-info" v-if="clientUserList.length!==0">
        <div v-for="(item,index) of clientUserList" @click="TransferWorkshop(item)" class="worker-info-item" :key="index">
          <img :src="getAvatar(item.avatarImageUri)" class="head-portrait"/>
          <div class="worker-info-detail">
            <div class="worker-info-detail-name">{{item.userName}}-{{item.userMobile}}</div>
            <div class="worker-info-detail-point">已获得积分：{{item.pointDTO.pointValue}}</div>
            <div  :class="['worker-info-detail-role',item.userRole==='02'?'worker-info-detail-role02':'worker-info-detail-role03']">{{item.userRoleName}}</div>
          </div>
          <div v-show="item.clientId!==clientId" class="change-btn">选择</div>
        </div>
      </div>
      <div v-else class="no-data">
        暂无数据
      </div>
    </div>

    <van-overlay :show="hintOverlay" @click="hintOverlay = false">
      <div class="wrapper-overlay" @click.stop>
        <div class="content-overlay">
          <div class="overlay-cancel" @click="hintOverlay = false">x</div>
          <div class="content-title">是否要转移店主身份？</div>
          <div class="overlay-block"></div>
          <div class="overlay-btn" @click="handleTransfer()">确定</div>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="resultOverlay" @click="resultOverlay = false">
      <div class="wrapper-overlay" @click.stop>
        <div class="content-overlay">
          <div class="content-title">转移成功，已登出当前账号！</div>
          <div class="overlay-block"></div>
          <div class="overlay-btn" @click="handleLogout()">确定</div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import Header from '../../components/header.vue'
import centerApi from '@/api/center.js'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import ssoLoginApi from '../../api/sso-login'
export default {
  components: { Header },
  data () {
    return {
      clientUserList: [],
      clientId: '',
      params: {
        userName: '',
        verifyCode: ''
      },
      disableSendBtn: false,
      countDownIndex: 0,
      clientUserId: '',
      isSelect: false,
      hintOverlay: false,
      resultOverlay: false
    }
  },
  computed: {
    countDownText () {
      return this.countDownIndex > 0 ? '(' + this.countDownIndex + ')' : ''
    }
  },
  created () {
    this.queryClientUserList()
  },
  methods: {
    getAvatar (img) {
      return commonUtils.getImageUrl(img)
    },
    queryClientUserList () {
      centerApi.queryClientUserList().then(res => {
        if (res.data.resultCode === '0') {
          this.clientUserList = res.data.resultData.clientUserList
        }
      })
    },
    getVerifyCode () {
      if (this.disableSendBtn) {
        return
      }
      centerApi.clientUserWorkshopTransferVerifyCode().then(res => {
        if (res.data.resultCode === '0') {
          this.countDownIndex = 60
          this.disableSendBtn = true
          this.countDown()
        }
      })
    },
    countDown () {
      this.countDownIndex = 60
      let _vm = this
      let timer = setInterval(() => {
        _vm.countDownIndex--
        if (_vm.countDownIndex === 0) {
          _vm.disableSendBtn = false
          clearInterval(timer)
        }
      }, 1000)
    },
    handleSelect () {
      this.isSelect = true
    },
    onSubmit () {
      console.log(this.params)
      if (!this.params.clientUserId) {
        this.$toast('请选择转移对象！')
        return
      }
      this.hintOverlay = true
    },
    TransferWorkshop (item) {
      this.params.userName = item.userName
      this.params.clientUserId = item.clientUserId
      if (this.params.clientUserId) {
        this.isSelect = false
      }
    },
    handleTransfer () {
      this.hintOverlay = false
      centerApi.clientUserWorkshopTransfer(this.params).then(res => {
        if (res.data.resultCode === '0') {
          this.resultOverlay = true
        }
      })
    },
    handleLogout () {
      ssoLoginApi.authLogout().then(res => {
        if (res.data.resultCode === '0') {
          this.resultOverlay = false
          userUtils.removeUserLocal()
          this.$router.push({ name: 'login2' })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.worker-info{
  margin: 20px  15px 0   15px;
  width: calc(100% - 30px);
}
.worker-info-item{
  background-color: #fff;
  border-radius: 5px;
  margin: 15px 0px;
  height: 80px;
  display: flex;
  position: relative;
  .head-portrait{
    margin: 10px;
    border-radius: 5px;
    vertical-align: middle;
  }
  .worker-info-detail{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .worker-info-detail-name{
    font-size: 16px;
    color: black;
  }
  .worker-info-detail-point{
    color: grey;
    font-size: 12px;
  }
  .worker-info-detail-role{
    text-align: center;
    font-size: 12px;
    padding: 2px;
    width: 40px;
    border-radius: 5px;
  }
}
.head-portrait{
  width: 60px;
  height: 60px;
}
  .change-btn{
    background-color: var(--base-green);
    text-align: center;
    color: white;
    border-radius: 12px;
    position: absolute;
    font-size: 12px;
    padding: 5px 17px;
    right: 10px;
    bottom: 6px;
  }
.worker-info-detail-role03{
    background-color: #e2eef0;
    color: #117181;
  }
  .worker-info-detail-role02{
    background-color: #f8f7db;
    color: #b9b56e;
  }
  .no-data{
    height:calc(100vh - 86px) ;
    margin-top:40px;
    text-align: center;
    color: grey;
  }
</style>
